import axios from 'axios';

import { getValidToken, clearToken } from './tokenManager';

const apiCard = axios.create();

apiCard.interceptors.request.use(async (config) => {
  if (!config.baseURL) {
    throw new Error('baseURL é obrigatório para apiCard');
  }

  const token = await getValidToken(config.baseURL);
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiCard.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 404) {
      window.location.href = `/not-available?message=${encodeURIComponent(
        'Você deve se conectar á rede Wi-Fi do estabelecimento para pedir!.',
      )}`;
    }
    if (error.response?.status === 401 && !originalRequest.retry) {
      originalRequest.retry = true;
      clearToken();
      const token = await getValidToken(originalRequest.baseURL);
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return apiCard(originalRequest);
    }

    return Promise.reject(error);
  },
);

export default apiCard;
